const commom = {
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },

    alertError(data) {
      if (data.message === "EXPIRED_TOKEN") {
        this.alertExpiredToken();
      } else {
        this.alertCustomError(data.message);
      }
    },

    alertExpiredToken() {
      this.$buefy.dialog.alert({
        title: "Sua sessão expirou",
        message: "Faça login novamente",
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        onConfirm: () => this.$router.push("/"),
        onCancel: () => this.$router.push("/")
      });
    },

    alertCustomError(err) {
      this.$buefy.dialog.alert({
        title: this.getAlertTitle(err),
        message: this.translateError(err),
        type: "is-warning",
        hasIcon: true,
        icon: "exclamation-triangle",
        iconPack: "fa"
      });
    },

    getAlertTitle(err) {
      let text = "Erro :(";
      if (
        err === "WAITING_LEADER_2_SIGNUP" ||
        err === "WAITING_LEADER_2_VALIDATE_EMAIL"
      ) {
        text = "Instruções";
      }
      return text;
    },

    translateError(message) {
      const translations = {
        ACCOUNT_DELETED:
          "Sua conta foi deletada, por favor, entre em contato conosco para recupera-la.",
        ACCOUNT_NOT_FOUND:
          "Não encontramos cadastro em nossa base com este email.",
        ACTION_NOT_PERMITTED: "Ação não permitida",
        ADD_AT_LEAST_ONE_URL_POST_COUNTERPART:
          "Você deve adicionar no mínimo uma URL referente ao post exigido pela contrapartida.",
        AT_LEAST_ONE_SOCIAL_NETWORK_IS_REQUIRED:
          "Você deve adicionar no mínimo uma rede social da OE",
        BEGIN_DATE_TOO_SOON:
          "Data de início da parceria é anterior à antecedência mínima estabelecida nos pré-requisitos.",
        BOTH_LEADERS_CANNOT_BE_THE_SAME_PERSON:
          "Os dois representantes não podem ser a mesma pessoa. Por favor, indique um representante diferente.",
        CELLPHONE_CANNOT_BE_EMPTY: "O celular não pode ser vazio",
        COULD_NOT_SIGN_IN_WITH_GOOGLE: "Não foi possível logar com o Google",
        DATES_1_AND_2_ARE_REPEATED:
          "Não são permitidas opções de datas repetidas (data 1 e data 2)",
        DATES_1_AND_3_ARE_REPEATED:
          "Não são permitidas opções de datas repetidas (data 1 e data 3)",
        DATES_2_AND_3_ARE_REPEATED:
          "Não são permitidas opções de datas repetidas (data 2 e data 3)",
        DATE_TOO_SOON:
          "A data é anterior à antecedência mínima estabelecida nos pré-requisitos.",
        DUPLICATED_CONTACTS:
          "Por favor, informe ao menos 2 outros contatos da OE que não sejam repetidos",
        DUPLICATED_COURSES:
          "Existem cursos duplicados na discriminação de graduandos por curso. Por favor, unifique-os.",
        END_DATA_MUST_BE_AFTER_BEGIN_DATE:
          "A data de término deve ser posterior à data de início",
        EMAIL_ALREADY_REGISTERED: "Este e-mail já está registrado, faça login.",
        EMAIL_CONFIRMATION_TOKEN_NOT_FOUND:
          "Não foi possível validar sua conta. Se estiver com dificuldades, por favor, entre em contato conosco pelo e-mail empower@empower.vision",
        EMAIL_CANNOT_BE_EMPTY: "O e-mail não pode ser vazio",
        FEEDBACK_CANNOT_BE_EMPTY: "O depoimento não pode ser vazio",
        FILE_EXTENSION_NOT_ALLOWED: "Esta extensão de arquivo não é permitida",
        FILE_IS_TOO_LARGE: "O arquivo é muito grande (max. 5mb)",
        FILE_IS_REQUIRED: "É obrigatório o envio de um arquivo",
        FIRST_DATE_IS_INVALID: "A data é inválida (data 1)",
        FIRST_DATE_MUST_BE_AFTER_TODAY:
          "A data precisa ser maior que hoje (data 1)",
        FIRST_DATE_OPTION_AFTER_LIMIT_DATE:
          "A primeira opção de data é posterior à data limite estabelecida para realização das ações.",
        FIRST_DATE_OPTION_TOO_SOON:
          "A primeira opção de data é anterior à antecedência mínima estabelecida nos pré-requisitos.",
        FIRST_DATE_END_TIME_IS_INVALID: "O horário de fim é inválido (data 1)",
        FIRST_DATE_END_TIME_CANNOT_BE_BEFORE_START_TIME:
          "O horário de fim não pode ser menor que o de início (data 1)",
        FIRST_DATE_START_TIME_IS_INVALID:
          "O horário de início é inválido (data 1)",
        FIRST_KNOWLEDGE_DEMAND_CANNOT_BE_EMPTY:
          "A 1a demanda (área / subárea) de conhecimento não pode ser vazia.",
        INFORM_AT_LEAST_TWO_OTHER_CONTACTS:
          "Por favor, informe ao menos 2 outros contatos na OE (nome + e-mail)",
        INFORM_STUDENTS_COURSES: "Informe os cursos dos estudantes",
        INVALID_AREA_CODE: "DDD inválido",
        INVALID_CATEGORY: "Categoria inválida",
        INVALID_CELLPHONE: "Celular inválido",
        INVALID_CITY:
          "Cidade inválida. Por favor, informe uma cidade presente na lista.",
        INVALID_OE_NAME: "Informe o nome da OE",
        INVALID_COUNTERPART: "Contrapartida inválida",
        INVALID_COURSE:
          "Curso inválido. Por favor, informe um curso presente na lista.",
        INVALID_COURSE_QUANTITY:
          "Digite um valor válido para a quantidade de graduandos em cada curso",
          INVALID_CREDENTIALS: `Credenciais inválidas.<br /><br />Caso você seja um professor de OE, faça login através da nossa plataforma para professores:<br />https://professor.empower.vision`,
        INVALID_EMAIL: "E-mail inválido",
        INVALID_FANPAGE:
          "Por favor, insira apenas a parte da URL que aparece após http://www.facebook.com/",
        INVALID_GRADUATION_DATE: "Data de formatura inválida",
        INVALID_INSTA:
          "Por favor, insira apenas a parte da URL que aparece após http://www.instagram.com/",
        INVALID_LINKEDIN:
          "Por favor, insira apenas a parte da URL que aparece após http://www.linkedin.com/company/",
        INVALID_FILE_NAME: "Nome da imagem inválido",
        INVALID_FIRST_KNOWLEDGE_AREA_DEMAND:
          "A área da demanda 1 de conhecimento é inválida",
        INVALID_FIRST_KNOWLEDGE_SUBAREA_DEMAND:
          "A sub-área da demanda 1 de conhecimento é inválida",
        INVALID_LEADER_1_AREA_CODE: "Informe um DDD válido para o seu celular",
        INVALID_LEADER_1_CELLPHONE: "Seu celular é inválido",
        INVALID_LEADER_2_AREA_CODE:
          "Informe um DDD válido para o celular do representante 2",
        INVALID_LEADER_2_CELLPHONE: "O celular do representante 2 é inválido",
        INVALID_LEADER_2_EMAIL: "E-mail do representante 2 inválido",
        INVALID_MENTORING_MIN_PUBLIC: "Público mínimo para mentoria inválido",
        INVALID_MONTH: "Mês inválido",
        INVALID_NAME: "Nome do representante inválido.",
        INVALID_OPPORTUNITY: "Oportunidade inválida",
        INVALID_ORGANIZATION_ALT_CATEGORY:
          'Categoria da OE inválida. Por favor, informe qual é a "outra" categoria da OE.',
        INVALID_ORGANIZATION_CATEGORY:
          "Categoria da OE inválida. Por favor, informe uma categoria presente na lista.",
        INVALID_ORGANIZATION_EMAIL: "E-mail institucional da OE inválido",
        INVALID_RECAPTCHA_TOKEN: "Ops, parece que o Recaptcha não foi carregado corretamente. Por favor, tente recarregar a tela.",
        INVALID_REQUEST: "Requisição inválida",
        INVALID_REQUEST_IS_ONLINE_FIELD:
          "Informe se a solicitação é para uma ação online ou presencial",
        INVALID_REQUEST_MIN_PUBLIC:
          "Não é permitido um valor menor que 1 no público estimado",
        INVALID_SECOND_KNOWLEDGE_AREA_DEMAND:
          "A área da demanda 2 de conhecimento é inválida",
        INVALID_SECOND_KNOWLEDGE_SUBAREA_DEMAND:
          "A sub-área da demanda 2 de conhecimento é inválida",
        INVALID_SPONSORSHIP_VALUE: "Valor de patrocínio inválido",
        INVALID_STATE:
          "Estado inválido. Por favor, informe uma UF presente na lista.",
        INVALID_STUDY_PERIOD: "Período de estudos inválido",
        INVALID_THIRD_KNOWLEDGE_AREA_DEMAND:
          "A área da demanda 3 de conhecimento é inválida",
        INVALID_THIRD_KNOWLEDGE_SUBAREA_DEMAND:
          "A sub-área da demanda 3 de conhecimento é inválida",
        INVALID_TREATMENT_PRONOUN: "Pronome de tratamento inválido",
        INVALID_TOKEN:
          "Token inválido ou expirado. Por favor, tente refazer o processo de recuperação de senha. Em caso de dúvida, mande um e-mail para empower@empower.vision.",
        INVALID_UNIVERSITY:
          "Universidade inválida. Por favor, informe uma universidade presente na lista.",
        INVALID_YEAR: "Ano inválido",
        LEADER_ALREADY_REGISTERED_FOR_THIS_ORGANIZATION:
          "O novo representante solicitado já está cadastrado como representante dessa oganização. Por favor, indique representante diferente",
        LEADER_HASNT_VALIDATED_EMAIL:
          "O representante ainda não validou o e-mail. É necessário fazê-lo antes de cadastrar a OE.",
        LEADER_NOT_FOUND:
          "Não encontramos o representante em nossa base. Por favor, certifique-se que ele já está cadastrado com esse e-mail fornecido.",
        LECTURE_NOT_AVAIABLE:
          "Palestra não está disponível para essa oportunidade, por favor, entre em contato conosco.",
        MENTORING_NOT_AVAIABLE:
          "Mentoria não está disponível para essa oportunidade, por favor, entre em contato conosco.",
        MISSING_BEGIN_DATE: "Insira a data de início",
        MISSING_END_DATE: "Insira a data de término",
        MISSING_EVENT_FORMAT: "Informe o formato da ação (presencial/online)",
        MISSING_EVENT_TYPE: "Informe o tipo de ação que deseja",
        MISSING_EVENT_NAME_PROJECT: "Informe o nome do evento / projeto",
        MISSING_EVENT_DESCRIPTION:
          "O contexto / descrição do evento precisa ter, no mínimo, 140 caracteres.",
        MISSING_FIRST_DATE:
          "Escolha ao menos a primeira opção de data para o evento",
        MISSING_FIRST_DATE_END_TIME:
          "Escolha um horario de fim para a primeira data",
        MISSING_FIRST_DATE_START_TIME:
          "Escolha um horario de início para a primeira data",
        MISSING_LEADER_1_POSITION: "Informe a posição que você ocupa na OE",
        MISSING_LEADER_2_COURSE: "Curso do representante 2 inválido",
        MISSING_LEADER_2_NAME: "Nome do representante 2 inválido",
        MISSING_LEADER_2_POSITION:
          "Informe a posição que o representante 2 ocupa na OE",
        MISSING_NEW_LEADER_POSITION:
          "Informe a posição que o novo representante ocupa na OE",
        MISSING_MEMBERS_COURSES_DETAILS:
          "Informe quais cursos e quantos membros da OE fazem cada um",
        MISSING_MENTORING_DESCRIPTION:
          "É preciso incluir uma descrição para a mentoria (min. 140 caracteres)",
        MISSING_MENTORING_QUESTION:
          "É preciso indicar as 3 principais questões a serem respondidas da mentoria (min. 20 caracteres cada resposta)",
        MISSING_MENTORING_THEME: "Insira um tema para a mentoria",
        MISSING_LECTURE_THEME: "Insira pelo menos um tema para a palestra",
        MISSING_ORGANIZATION_BRAND_STRENGTHENING:
          "Descreva como sua OE pode ajudar no fortalecimento das Empresas Mentoras em sua universidade",
        MISSING_ORGANIZATION_CATEGORY:
          "Qual a categoria da OE que você faz parte?",
        MISSING_ORGANIZATION_EVENTS:
          "Descreva os principais eventos da sua OE nos próximos 12 meses, informando datas e estimativa de participantes",
        MISSING_ORGANIZATION_HAS_EVENTS: "Informe se sua OE realiza eventos",
        MISSING_ORGANIZATION_HAS_PROJECTS: "Informe se sua OE realiza projetos",
        MISSING_ORGANIZATION_MEMBERS_COURSES_DETAILS:
          "Detalhe os cursos dos intergantes da OE, em ordem decrescente. Ex.: Economia (5), Eng. Mecânica (3), Eng. Produção (2)...",
        MISSING_ORGANIZATION_NAME: "Qual o nome da sua OE?",
        MISSING_ORGANIZATION_OBJECTIVES:
          "Descreva os principais objetivos da sua OE",
        MISSING_ORGANIZATION_PROJECTS:
          "Descreva os principais projetos da sua OE",
        MISSING_OTHER_CATEGORY:
          "Especifique qual outra categoria a OE faz parte",
        MISSING_OTHER_UNIVERSITY:
          "Especifique qual outra universidade a OE faz parte",
        MISSING_PLANT: "É preciso escolher uma planta",
        MISSING_PROJECT_NAME: "Insira o nome do projeto",
        MISSING_PROJECT_THEME: "Insira pelo menos um tema para o projeto",
        MISSING_PROJECT_TYPE: "Insira a categoria da parceria",
        MISSING_SECOND_DATE_END_TIME:
          "Escolha um horario de fim para a segunda data",
        MISSING_SECOND_DATE_START_TIME:
          "Escolha um horario de início para a segunda data",
        MISSING_THIRD_DATE_END_TIME:
          "Escolha um horario de fim para a terceira data",
        MISSING_THIRD_DATE_START_TIME:
          "Escolha um horario de início para a terceira data",
        MISSING_TRAINING_THEME: "Insira pelo menos um tema para o treinamento",
        MISSING_VARIOUS_UNIVERSITIES: "Insira as universidades que sua OE atua",
        MISSING_WEBINAR_THEME: "Insira pelo menos um tema para o webinar",
        MUST_ACCEPT_TERMS_AND_CONDITIONS:
          "É preciso ler e aceitar a nossa Política de Privacidade e os Termos e Condições de Uso da plataforma",
        MUST_INFORM_EMPOWER_DISCOVERY:
          "Por favor, informe como ficou sabendo da Empower",
        NAME_CANNOT_BE_EMPTY: "O nome não pode ser vazio",
        OPPORTUNITY_NOT_ACTIVE: "Esta oportunidade não está ativa.",
        OPPORTUNITY_NOT_FOUND:
          "Oportunidade não encontrada, por favor, entre em contato conosco.",
        ORGANIZATION_ALREADY_REGISTERED:
          "Aparentemente, sua OE já está registrada ou está com um pedido de registro aberto. Por favor, procure os representantes da OE ou entre em contato conosco pelo e-mail empower@empower.vision",
        ORGANIZATION_MEMBERS_PERMANENCE_MUST_BE_A_NUMBER_GREATER_THAN_ZERO:
          "A quantidade média de meses de permanência dos membros na OE precisa ser maior que 0",
        ORGANIZATION_MEMBERS_PERMANENCE_MUST_BE_A_NUMBER_WITHOUT_SYMBOLS:
          "A quantidade média de meses de permanência dos membros na OE precisa ser um número sem símbolos",
        ORGANIZATION_MEMBERS_QUANTITY_MUST_BE_A_NUMBER_GREATER_THAN_ZERO:
          "A quantidade de integrantes da OE precisa ser maior que 0",
        ORGANIZATION_MEMBERS_QUANTITY_MUST_BE_A_NUMBER_WITHOUT_SYMBOLS:
          "A quantidade de integrantes da OE precisa ser um número sem símbolos",
        ORGANIZATION_NOT_FOUND: "OE não encontrada",
        ORGANIZATION_BLACK_MEMBERS_QUANTITY_MUST_BE_A_NUMBER_WITHOUT_SYMBOLS:
          "A quantidade de integrantes negros da OE precisa ser um número sem símbolos",
        ORGANIZATION_LGBTI_MEMBERS_QUANTITY_MUST_BE_A_NUMBER_WITHOUT_SYMBOLS:
          "A quantidade de integrantes LGBTQIA+ da OE precisa ser um número sem símbolos",
        ORGANIZATION_WOMEN_MEMBERS_QUANTITY_MUST_BE_A_NUMBER_WITHOUT_SYMBOLS:
          "A quantidade de integrantes mulheres da OE precisa ser um número sem símbolos",
        OTHER_ACTIONS_NOT_AVAIABLE:
          "Esta empresa não aceita outras ações. Por favor, entre em contato com a Empower.",
        OTHER_CONTACTS_INVALID_EMAIL: "E-mail do contato adicional inválido",
        OTHER_CONTACTS_INVALID_NAME: "Nome do contato adicional inválido",
        OTHER_CONTACTS_MUST_BE_DIFFERENT_FROM_LEADERS:
          "Os outros contatos da OE não podem ser os representes 1 e 2.",
        OTHER_CONTACTS_MUST_HAVE_NAME_AND_EMAIL:
          "Por favor, informe nome e e-mail de todos os contatos adicionais da OE (pelo menos 2).",
        PASSWORD_MUST_HAVE_AT_LEAST_5_CHARACTERS:
          "Por favor, escolha uma senha com, no mínimo, 5 caracteres",
        PLANT_NOT_AVAIABLE:
          "Esta planta não está disponível, por favor, entre em contato conosco.",
        PLEASE_REGISTER_BEFORE_LOGIN:
          "Por favor, crie uma conta com este e-mail antes de fazer login.",
        PROJECT_DESCRIPTION_TOO_SHORT:
          "Descreva o projeto com, pelo menos, 140 caracteres - um tweet antigo :)",
        PROJECT_NOT_AVAIABLE:
          "Projeto não está disponível, por favor, entre em contato conosco.",
        PROVIDE_CONTACT_OR_INSTAGRAM: "Informe contato ou instagram",
        REQUESTS_CAN_ONLY_BE_MADE_BY_LEADERS:
          "É preciso ser representante da OE para fazer solicitações",
        REQUEST_NOT_FOUND: "Solicitação não encontrada",
        REQUEST_TYPE_MUST_BE_LECTURE:
          "É preciso que o tipo de solicitação seja 'Palestra'",
        REQUEST_TYPE_MUST_BE_MENTORING:
          "É preciso que o tipo de solicitação seja 'Mentoria'",
        REQUEST_TYPE_MUST_BE_OTHER:
          "É preciso que o tipo de solicitação seja 'Outra'",
        REQUEST_TYPE_MUST_BE_PROJECT:
          "É preciso que o tipo de solicitação seja 'Projeto'",
        REQUEST_TYPE_MUST_BE_SPONSORSHIP:
          "É preciso que o tipo de solicitação seja 'Patrocínio'",
        REQUEST_TYPE_MUST_BE_TRAINING:
          "É preciso que o tipo de solicitação seja 'Treinamento'",
        REQUEST_TYPE_MUST_BE_VISIT:
          "É preciso que o tipo de solicitação seja 'Visita'",
        REQUEST_TYPE_MUST_BE_WEBINAR:
          "É preciso que o tipo de solicitação seja 'Webinar'",
        SECOND_DATE_END_TIME_CANNOT_BE_BEFORE_START_TIME:
          "O horário de fim não pode ser menor que o de início (data 2)",
        SECOND_DATE_MUST_BE_AFTER_TODAY:
          "A data precisa ser maior que hoje (data 2)",
        SECOND_DATE_OPTION_AFTER_LIMIT_DATE:
          "A segunda opção de data é posterior à data limite estabelecida para realização das ações.",
        SECOND_DATE_OPTION_TOO_SOON:
          "A segunda opção de data é anterior à antecedência mínima estabelecida nos pré-requisitos.",
        SECOND_KNOWLEDGE_DEMAND_CANNOT_BE_EMPTY:
          "A 2a demanda (área / subárea) de conhecimento não pode ser vazia.",
        SEEMS_A_BOT:
          "Ops, o Google Recaptcha acha que você é um bot. Por favor, preencha novamente as informações do formulário digitando-as, sem colá-las.",
        SPONSORSHIP_NOT_AVAIABLE:
          "Patrocínio não está disponível, por favor, entre em contato conosco.",
        STATE_NOT_AVAIABLE_FOR_LECTURE:
          "Sua OE não está em um dos estados na qual essa empresa mentora oferece palestras. Em caso de dúvida, por favor, entre em contato conosco.",
        STATE_NOT_AVAIABLE_FOR_MENTORING:
          "Sua OE não está em um dos estados na qual essa empresa mentora oferece mentorias. Em caso de dúvida, por favor, entre em contato conosco.",
        STATE_NOT_AVAIABLE_FOR_PROJECT:
          "Sua OE não está em um dos estados na qual essa empresa mentora oferece projetos. Em caso de dúvida, por favor, entre em contato conosco.",
        STATE_NOT_AVAIABLE_FOR_SPONSORSHIP:
          "Sua OE não está em um dos estados na qual essa empresa mentora oferece patrocínios. Em caso de dúvida, por favor, entre em contato conosco.",
        STATE_NOT_AVAIABLE_FOR_TRAINING:
          "Sua OE não está em um dos estados na qual essa empresa mentora oferece treinamentos. Em caso de dúvida, por favor, entre em contato conosco.",
        STATE_NOT_AVAIABLE_FOR_WEBINAR:
          "Sua OE não está em um dos estados na qual essa empresa mentora oferece webinars. Em caso de dúvida, por favor, entre em contato conosco.",
        STUDENT_IS_LEADER_ALREADY:
          "Este estudante já é representante de uma organização. Por favor, indique outro representante.",
        STUDENT_NOT_FOUND:
          "Não encontramos esse e-mail em nossa base. Caso este estudante ainda não esteja cadastrado, ele precisará se cadastrar com o mesmo e-mail que você informar aqui, ok?",
        SURNAME_CANNOT_BE_EMPTY: "O sobrenome não pode ser vazio",
        TRAINING_NOT_AVAIABLE:
          "Treinamento não está disponível para essa oportunidade, por favor, entre em contato conosco.",
        THEMES_DESCRIPTION_TOO_SHORT:
          "Descreva as sugestões de temas com, pelo menos, 140 caracteres - um tweet antigo :)",
        THIRD_DATE_END_TIME_CANNOT_BE_BEFORE_START_TIME:
          "O horário de fim não pode ser menor que o de início (data 3)",
        THIRD_DATE_MUST_BE_AFTER_TODAY:
          "A data precisa ser maior que hoje (data 3)",
        THIRD_DATE_OPTION_AFTER_LIMIT_DATE:
          "A terceira opção de data é posterior à data limite estabelecida para realização das ações.",
        THIRD_DATE_OPTION_TOO_SOON:
          "A terceira opção de data é anterior à antecedência mínima estabelecida nos pré-requisitos.",
        THIRD_KNOWLEDGE_DEMAND_CANNOT_BE_EMPTY:
          "A 3a demanda (área / subárea) de conhecimento não pode ser vazia.",
        TOTAL_IS_DIFFERENT_FROM_NUMBER_OF_STUDENTS:
          "O número de graduandos da OE precisa bater com a soma dos graduandos por curso",
        TOO_FEW_ATTENDEES:
          "Quantidade de participantes inferior ao mínimo estabelecido nos pré-requisitos.",
        TOO_MANY_LOGIN_ATTEMPTS:
          "Você atingiu o limite de 5 tentativas malsucedidas de login a cada 5 minutos. Por segurança, aguarde 5 minutos para tentar novamente ou redefina sua senha.",
        TOO_MUCH_ATTENDEES:
          "Quantidade de participantes superior ao máximo estabelecido nos pré-requisitos.",
        UNEXPECTED_ERROR: "Por favor, tente novamente mais tarde..",
        USER_MUST_ACCEPT_TERMS:
          "Você deve aceitar os termos de contrapartida ao fazer a solicitação",
        USER_NOT_FOUND: "Este e-mail não está cadastrado em nossa base.",
        VISIT_NOT_AVAIABLE:
          "Visita não está disponível para essa oportunidade, por favor, entre em contato conosco.",
        WAITING_LEADER_2_SIGNUP:
          "O representante 2 precisa se cadastrar na Plataforma Empower para podermos seguir com o processo de aprovação da OE.",
        WAITING_LEADER_2_VALIDATE_EMAIL:
          "O representante 2 precisa validar o e-mail para podermos seguir com o processo de aprovação da OE.",
        WEBINAR_NOT_AVAIABLE:
          "Webinar não está disponível para essa oportunidade, por favor, entre em contato conosco.",
        WRONG_PASSWORD: "Senha atual incorreta!"
      };
      return translations[message] || "Por favor, tente novamente mais tarde..";
    }
  }
};

export { commom };
